import { ThemeUIStyleObject } from "theme-ui"

export const wrapStyles: ThemeUIStyleObject = {
  overflowX: "auto",
  maxWidth: "width.2",
}

export const lightLayoutWrapStyles: ThemeUIStyleObject = {
  maxWidth: "width.2",
}

export const containerStyles: ThemeUIStyleObject = {
  display: "flex",
  flexDirection: "column",
  mr: "auto",
  ml: "auto",
}

export const containerMobileStackStyles: ThemeUIStyleObject = {
  display: [null, "flex"],
  flexDirection: [null, "column"],
  mr: "auto",
  ml: "auto",
}

export const rowBaseStyle: ThemeUIStyleObject = {
  display: "flex",
  px: [4, 6],
}

export const rowBaseStackOnMobileStyle: ThemeUIStyleObject = {
  display: [null, "flex"],
  px: [4, 6],
}

export const rowHeaderStyles: ThemeUIStyleObject = {
  bg: "darkGreen",
  color: "copper",
  fontSize: ["paragraphMedium", "paragraphLarge"],
  pt: 5,
  pb: 5,
  "& h3": {
    fontFamily: "body",
    mb: 0,
  },
  "& p": {
    fontSize: ["paragraphSmall", "paragraph"],
    mb: 2,
    color: "copper",
  },
  "& p:last-of-type": {
    mb: 0,
  },
  "& + div": {
    pt: 5,
  },
}

export const rowStyles: ThemeUIStyleObject = {
  bg: "white",
  ":last-of-type": {
    textAlign: "right",
    pb: 5,
  },
}
export const lightLayoutRowStyles: ThemeUIStyleObject = {
  px: 0,
  py: 7,
  borderTop: "1px solid white",
  ":last-of-type": {
    textAlign: "right",
    pb: 5,
    borderBottom: "1px solid white",
  },
}

export const cellHeaderStyle: ThemeUIStyleObject = {}

export const cellStyles: ThemeUIStyleObject = {
  fontSize: ["paragraphSmall", "paragraph"],
  pb: 5,
  pl: [2, 3],
  pr: [2, 3],
  "& p": {
    fontFamily: "body",
    fontSize: ["paragraphSmall", "paragraph"],
    ":last-of-type": {
      mb: 0,
    },
  },
  "& strong": {
    fontFamily: "heading",
  },
  ":last-of-type": {
    width: "40%",
    textAlign: "right",
    pr: 0,
  },
  ":first-of-type": {
    width: "60%",
    textAlign: "left",
    pl: 0,
  },
}

export const cellStackStyles: ThemeUIStyleObject = {
  ...cellStyles,
  ...{
    ":last-of-type": {
      width: ["100%", "40%"],
      textAlign: ["left", "right"],
      pr: 0,
      pl: [0, 3],
    },
    ":first-of-type": {
      width: ["100%", "60%"],
      textAlign: "left",
      pl: 0,
      pb: [2, 5],
    },
  },
}

export const contentStyles: ThemeUIStyleObject = {
  ".emphasize": {
    color: "ochre",
  },
}

export const lightLayoutContentStyles: ThemeUIStyleObject = {
  ".emphasize": {
    color: "ochre",
  },
}
